import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  menu: false,
  dark: false,
  service: null,
};

export const commonSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setMenu: (state, action) => {
      state.menu = action.payload;
    },
    setDark: (state, action) => {
      state.dark = action.payload;
    },
  },
});

export const { setDark, setMenu } = commonSlice.actions;
export default commonSlice.reducer;
